<span class="typo-h5-book ml-2 leading-none">{{ labelTranslationKey() | translate }}</span>
<div
  class="flex items-center justify-start rounded-2xl border border-solid"
  [ngClass]="errorState() ? 'border-states-red' : 'border-text-extra-light'"
  [class.bg-background-disabled]="disabled()"
>
  <button (click)="datePicker.clickCalendarButton()" [disabled]="disabled()" class="flex h-10 w-[156px] items-center justify-between px-3">
    <span class="typo-h4-medium leading-none" [ngClass]="disabled() || !selectedDate() ? 'text-text-light' : 'text-text-primary'">{{
      selectedDate() ? (selectedDate()?.toString() | date: 'MM/dd/yyyy') : 'mm/dd/yyyy'
    }}</span>
    @if (!disabled()) {
      <svg-icon class="text-text-tertiary" key="px-24-calendar"></svg-icon>
    }
  </button>
  <lib-date-picker
    #datePicker
    class="pointer-events-none absolute opacity-0"
    [date]="selectedDate()"
    (dateChange)="onDateSelect($event)"
    [minDate]="minDate()"
    todayButtonPosition="footer"
  />
</div>
